import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as actions from './actions';
import { IndexType } from '@fnModels/algolia/algolia';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';

export type MortgageBrokerSearchStateModel = AlgoliaBaseState<unknown>;

@State<MortgageBrokerSearchStateModel>({
	name: 'mortgageBrokerSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class MortgageBrokerSearchState extends AlgoliaSearchState<MortgageBrokerSearchStateModel> {
	protected indexName = getIndex(IndexType.MORTGAGE_BROKERS);

	@Selector([MortgageBrokerSearchState])
	static getList(state: MortgageBrokerSearchStateModel): unknown[] {
		return state?.items;
	}

	@Selector([MortgageBrokerSearchState])
	static getSearching(state: MortgageBrokerSearchStateModel): boolean {
		return state?.searching;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<MortgageBrokerSearchStateModel>,
		{ searchTerm }: actions.Search,
	): Promise<void> {
		await this.algoliaSearchHandler(ctx, searchTerm);
	}
}
